<template>
    <div>
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between align-items-start">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{trans('permission.assign_permission')}}</h3>
                    <div class="nk-block-des text-soft">
                        <p>Toggle capabilities by role and save the matrix once after review.</p>
                    </div>
                </div>
                <router-link to="/configuration/permission" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline">{{trans('general.back')}}</router-link>
            </div>
        </div>
        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="permission"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner admin-config-panel__inner--wide">
                    <div class="admin-linear-stats">
                        <div>
                            <span>{{ trans('role.role') }}</span>
                            <strong>{{ roles.length }}</strong>
                        </div>
                        <div>
                            <span>{{ trans('permission.permission') }}</span>
                            <strong>{{ permissions.length }}</strong>
                        </div>
                    </div>
                    <show-tip module="permission" tip="tip_assign_permission"></show-tip>
                    <section class="admin-config-section admin-linear-matrix-section mt-3" :aria-label="trans('permission.assign_permission')">
                        <div class="admin-list-table-card admin-config-list-card">
                            <div class="table-responsive">
                                <table class="table admin-data-table admin-data-table--config-list admin-linear-matrix-table mb-0">
                                    <thead>
                                        <tr>
                                            <th scope="col">{{trans('permission.permission')}}</th>
                                            <th v-for="role in roles" :key="role.id" scope="col" class="text-center">{{role.name}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="permission in permissions" :key="permission.id">
                                            <td>
                                                <strong class="admin-linear-primary">{{toWord(permission.name)}}</strong>
                                                <span class="admin-linear-muted">{{ permission.name }}</span>
                                            </td>
                                            <td v-for="role in roles" :key="role.id" class="text-center">
                                                <switches v-model="assignPermissionForm.data[role.id][permission.id]" theme="bootstrap" color="success"></switches>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="admin-config-actions">
                            <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" @click="savePermission">{{trans('general.save')}}</button>
                            <router-link to="/configuration/permission" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline">{{trans('general.back')}}</router-link>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import configurationSidebar from '../system-config-sidebar'
    import switches from 'vue-switches'

    export default {
        components: {configurationSidebar,switches},
        data() {
            return {
                roles: [],
                permissions: [],
                assignPermissionForm: new Form({
                    data: {}
                })
            }
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }
            axios.get('/api/permission/assign/pre-requisite')
                .then(response => response.data)
                .then(response => {
                    this.permissions = response.permissions;
                    this.roles = response.roles;
                    this.assignPermissionForm.data = response.data;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
        },
        methods:{
            savePermission(){
                axios.post('/api/permission/assign',{
                    data: this.assignPermissionForm.data
                })
                .then(response => response.data)
                .then(response => {
                    toastr.success(response.message);
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
            },
            toWord(str){
                return helper.toWord(str);
            }
        }
    }
</script>

<style scoped>
.admin-linear-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1.25rem;
    margin-bottom: 1.25rem;
    padding: 1.1rem 1.2rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.06), var(--dash-pro-surface));
}

.admin-linear-head__eyebrow,
.admin-linear-section-head span {
    display: block;
    color: var(--lms-primary);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.admin-linear-head__title {
    margin: 0.35rem 0 0;
    color: var(--dash-pro-text);
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: -0.04em;
}

.admin-linear-head__description {
    max-width: 42rem;
    margin: 0.45rem 0 0;
    color: var(--dash-pro-muted);
    font-size: 0.875rem;
    line-height: 1.55;
}

.admin-linear-stats {
    display: grid;
    grid-template-columns: repeat(2, minmax(6rem, 1fr));
    min-width: 16rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: var(--dash-pro-surface);
}

.admin-linear-stats > div {
    padding: 0.85rem 1rem;
    border-right: 1px solid var(--dash-pro-border);
}

.admin-linear-stats > div:last-child {
    border-right: 0;
}

.admin-linear-stats span {
    display: block;
    color: var(--dash-pro-muted);
    font-size: 0.72rem;
    font-weight: 700;
}

.admin-linear-stats strong {
    display: block;
    margin-top: 0.25rem;
    color: var(--dash-pro-text);
    font-size: 1.65rem;
    letter-spacing: -0.06em;
}

.admin-linear-section-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
}

.admin-linear-section-head .admin-config-section__title {
    margin-top: 0.35rem;
}

.admin-linear-primary {
    display: block;
    color: var(--dash-pro-text);
    font-weight: 650;
    white-space: nowrap;
}

.admin-linear-muted {
    display: block;
    margin-top: 0.2rem;
    color: var(--dash-pro-muted);
    font-size: 0.75rem;
    white-space: nowrap;
}

.admin-linear-matrix-table {
    min-width: 760px;
}

@media (max-width: 767.98px) {
    .admin-linear-head,
    .admin-linear-section-head {
        align-items: stretch;
        flex-direction: column;
    }

    .admin-linear-stats {
        min-width: 0;
    }
}
</style>
